import { render, staticRenderFns } from "./history-chart.vue?vue&type=template&id=512f07c4&scoped=true"
import script from "./history-chart.vue?vue&type=script&lang=js"
export * from "./history-chart.vue?vue&type=script&lang=js"
import style0 from "./history-chart.vue?vue&type=style&index=0&id=512f07c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f07c4",
  null
  
)

export default component.exports